import { useContext } from 'react';

import { PromoPresentationContext } from '../contexts/PromoPresentationProvider';

export const usePromoPresentation = () => useContext(PromoPresentationContext);
